import { Link } from "react-router-dom";
import TrustBadges from "./TrustBadges";

const Footer = () => {
  return (
    <footer data-testid="footer">
      <div className="footer-grid">
        <div>
          <span className="footer-brand-name">Amatya</span>
          <span className="footer-brand-dev">अमात्य</span>
          <p className="footer-tagline">"Your Celestial Counselor for Life's Journey"</p>
          <div className="footer-trust">
            Secure payments via Razorpay.<br/>
            All rituals video and photo documented.<br/>
            5–7 working day delivery across India.<br/>
            No fear-based predictions. Ever.
          </div>
          <TrustBadges variant="footer" />
          {/* Social Media Icons */}
          <div style={{display:'flex', gap:'16px', marginTop:'20px'}}>
            <a href="https://www.instagram.com/amatyalive/" target="_blank" rel="noopener noreferrer" style={{color:'#D4A843', transition:'color 0.3s'}} data-testid="footer-instagram">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
            </a>
            <a href="https://x.com/amatyalive" target="_blank" rel="noopener noreferrer" style={{color:'#D4A843', transition:'color 0.3s'}} data-testid="footer-twitter">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
            </a>
            <a href="https://www.youtube.com/@amatyalive" target="_blank" rel="noopener noreferrer" style={{color:'#D4A843', transition:'color 0.3s'}} data-testid="footer-youtube">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
            </a>
            <a href="https://www.facebook.com/share/17c4yBvjvX/" target="_blank" rel="noopener noreferrer" style={{color:'#D4A843', transition:'color 0.3s'}} data-testid="footer-facebook">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            </a>
          </div>
        </div>
        <div>
          <div className="footer-col-title">Services</div>
          <ul className="footer-links">
            <li><Link to="/services#astro">Astro Analysis</Link></li>
            <li><Link to="/services#yagya">Yagya Ceremonies</Link></li>
            <li><Link to="/services#sankalpa">Sankalpa</Link></li>
            <li><Link to="/services#vastra">Vastra Daan</Link></li>
            <li><Link to="/services#bhojan">Bhojan Daan</Link></li>
          </ul>
        </div>
        <div>
          <div className="footer-col-title">Navigate</div>
          <ul className="footer-links">
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/stories">Stories</Link></li>
            <li><Link to="/blogs" data-testid="footer-blogs">Blogs</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
            <li><Link to="/my-consultation">My Consultation</Link></li>
            <li><Link to="/begin-journey">Begin Journey</Link></li>
          </ul>
        </div>
        <div>
          <div className="footer-col-title">Legal</div>
          <ul className="footer-links">
            <li><Link to="/terms-of-use" data-testid="footer-terms-of-use">Terms of Use</Link></li>
            <li><Link to="/privacy-policy" data-testid="footer-privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/disclaimer" data-testid="footer-disclaimer">Disclaimer</Link></li>
            <li><Link to="/cookie-policy" data-testid="footer-cookie-policy">Cookie Policy</Link></li>
            <li><Link to="/spiritual-services-agreement" data-testid="footer-spiritual-agreement">Spiritual Services Agreement</Link></li>
            <li><Link to="/cancellation-policy" data-testid="footer-cancellation-policy">Cancellation & Refund Policy</Link></li>
          </ul>
        </div>
        <div>
          <div className="footer-col-title">Reach Us</div>
          <ul className="footer-links">
            <li><a href="https://wa.me/917633997555" target="_blank" rel="noopener noreferrer">WhatsApp Consultation</a></li>
            <li><a href="mailto:hello@amatya.in">Write to Us</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© 2026 ANS LEGAL AND BUSINESS SERVICES LLP. All rights reserved.</span>
        <span className="footer-mantra">॥ सत्यमेव जयते ॥</span>
        <span>Crafted with reverence and care.</span>
      </div>
    </footer>
  );
};

export default Footer;
